module.exports = __webpack_public_path__ + "static/media/news-10.f3f7e7bd.jpg";